var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{
    'button--selected' : _vm.selected,
    'button--non-selected':!_vm.selected,
    'button--disabled':_vm.disabled },attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }